import {
  Feature,
  Geometry,
  Polygon,
  LineString,
  Point,
  MultiLineString,
  MultiPolygon,
  FeatureLayerInfo
} from '../../models'

import {getMapService} from '../../reducers/map'
import {GeometryType} from '../../enums/GeometryType'

interface IGeometryAttribute {
  SRID: number
  Coordinates?: {X: number; Y: number; Z: number}[]
  X?: number
  Y?: number
}
export class XyParser {
  localDbGuidFieldName: string
  localDbStatusFieldName: string
  public geometryToAttribute(geometryType: GeometryType, geometry?: Geometry): IGeometryAttribute | null {
    const result = null
    if (geometry) {
      let geomObj: any = null
      if (geometryType == GeometryType.Polygon) {
        // let coordiantes = (geometry as Polygon).getCoordinates().map(ring => ring.map((c: number[][]) => {return {X: c[0], Y: c[1]}}));
        geomObj = {
          SRID: getMapService().getSRID(),
          // Coordinates: (geometry as Polygon).getCoordinates()[0].map((c: number[][]) => {return {X: c[0], Y: c[1]}})
          Coordinates: (geometry as Polygon).getCoordinates().map(ring =>
            ring.map((c: any) => {
              return {X: c[0], Y: c[1]}
            })
          )
        }
      } else if (geometryType == GeometryType.LineString) {
        geomObj = {
          SRID: getMapService().getSRID(),
          Coordinates: (geometry as LineString).getCoordinates().map(c => {
            return {X: c[0], Y: c[1]}
          })
        }
      } else if (geometryType == GeometryType.Point) {
        geomObj = {
          SRID: getMapService().getSRID(),
          X: (geometry as Point).getCoordinates()[0],
          Y: (geometry as Point).getCoordinates()[1]
        }
      } else if (geometryType == GeometryType.MultiLineString) {
        const coords: {X: number; Y: number}[][] = []
        const liens = (geometry as MultiLineString).getCoordinates()
        liens.forEach((l: number[][]) => {
          const coordinates: {X: number; Y: number}[] = []
          l.forEach(c => {
            coordinates.push({X: c[0], Y: c[1]})
          })
          coords.push(coordinates)
        })
        geomObj = {
          SRID: getMapService().getSRID(),
          Coordinates: coords
        }
      } else if (geometryType == GeometryType.MultiPolygon) {
        geomObj = {
          SRID: getMapService().getSRID(),
          Polygons: (geometry as MultiPolygon).getCoordinates().map(polyCoords => {
            return this.geometryToAttribute(GeometryType.Polygon, new Polygon(polyCoords))
          })
        }
      } else {
        throw new Error(`${geometryType} not implemented`)
      }
      return geomObj
    }

    return result
  }

  protected setGeometry(d: any, layerInfo: FeatureLayerInfo, feature: Feature) {
    let type = GeometryType.None
    let geometryFieldName = ''
    for (const field in layerInfo.fields) {
      if (layerInfo.fields[field].type == 'geometry') {
        type = layerInfo.fields[field].geometryType
        geometryFieldName = field
      }
    }
    if (type != GeometryType.None && d[geometryFieldName]) {
      let geometry: Geometry | undefined = undefined
      if (type == GeometryType.Point) {
        geometry = new Point([d[geometryFieldName].X, d[geometryFieldName].Y])
      } else if (type == GeometryType.LineString) {
        const coordinates: [number, number][] = []
        d[geometryFieldName].Coordinates.forEach((c: {X: number; Y: number; Z: number}) => {
          coordinates.push([c.X, c.Y])
        })
        geometry = new LineString(coordinates)
      } else if (
        type == GeometryType.Polygon &&
        d[geometryFieldName].Coordinates &&
        d[geometryFieldName].Coordinates.length > 0
      ) {
        //these coordinates are only for the first ring - no holes supporter: TODO
        const coordinates: [number, number][][] = []
        d[geometryFieldName].Coordinates.forEach((ring: {X: number; Y: number; Z: number}[]) => {
          const rings: [number, number][] = []
          ring.forEach((c, i: number) => {
            if (i == ring.length - 1 && rings[0][0] == c.X && rings[0][1] == c.Y) {
              return
            }
            rings.push([c.X, c.Y])
          })
          coordinates.push(rings)
        })
        geometry = new Polygon(coordinates)
      } else if (type == GeometryType.MultiLineString) {
        const allCoordinates: [number, number][][] = []
        d[geometryFieldName].LineStrings.forEach(
          (p: {Coordinates: {X: number; Y: number; Z: number}[]; SRID: number}) => {
            const coordinates: [number, number][] = []
            p.Coordinates.forEach(c => {
              coordinates.push([c.X, c.Y])
            })
            allCoordinates.push(coordinates)
          }
        )

        geometry = new MultiLineString(allCoordinates)
      } else if (type == GeometryType.MultiPolygon && d[geometryFieldName].Polygons) {
        const allCoordinates: [number, number][][][] = []
        //these coordinates are only for the first ring - no holes supporter: TODO
        d[geometryFieldName].Polygons.forEach(
          (p: {Coordinates: {X: number; Y: number; Z: number}[][]; SRID: number}) => {
            const coordinates: [number, number][][] = []
            p.Coordinates.forEach(ring => {
              const ringCoords: [number, number][] = []
              ring.forEach((c, i) => {
                if (i == ring.length - 1 && ringCoords[0][0] == c.X && ringCoords[0][1] == c.Y) {
                  return
                }
                ringCoords.push([c.X, c.Y])
              })
              coordinates.push(ringCoords)
            })
            allCoordinates.push(coordinates)
          }
        )

        geometry = new MultiPolygon(allCoordinates)
      }
      feature.setGeometry(geometry)
    }
  }

  public parseFeatures(layerInfo: FeatureLayerInfo, data: any): Array<Feature> {
    const features: Array<Feature> = []
    data.forEach((d: any) => {
      const feature: Feature = new Feature()

      this.setGeometry(d, layerInfo, feature)
      feature.setId(d[layerInfo.sourceDescription.idField])
      if (this.localDbGuidFieldName && d[this.localDbGuidFieldName]) {
        feature.guid = d[this.localDbGuidFieldName]
        feature.localDbStatus = d[this.localDbStatusFieldName]
      }
      feature.setProperties(d)
      features.push(feature)
    })
    return features
  }
  protected getLocalISOTime(twDate: Date): string {
    // obtain local UTC offset and convert to msec
    const localOffset = twDate.getTimezoneOffset() * 60000
    const newdate = new Date(twDate.getTime() - localOffset)
    return newdate.toISOString().replace('.000', '')
  }

  public featureToAttributes(feature: Feature, layerInfo: FeatureLayerInfo): {[key: string]: any} {
    const atts = feature.getProperties()

    delete atts['geometry']
    for (const fieldName in layerInfo.fields) {
      const fieldInfo = layerInfo.fields[fieldName]

      if (fieldInfo.type == 'date' && atts[fieldName]) {
        atts[fieldName] = new Date(atts[fieldName])
        if (fieldInfo.dateSupportsOffset) {
          atts[fieldName] = atts[fieldName].toISOString()
        } else {
          atts[fieldName] = this.getLocalISOTime(atts[fieldName])
        }
      } else if (fieldInfo.type == 'geometry') {
        delete atts[fieldInfo.fieldName]
        const geom = feature.getGeometry()
        const geomAtt = this.geometryToAttribute(layerInfo.getGeometryType(), geom)
        if (geomAtt) {
          atts[fieldInfo.fieldName] = geomAtt
        }
      }
    }
    for (const at in atts) {
      if (atts[at] instanceof Feature) {
        console.warn('TODO: implement related features')
        delete atts[at]
      }
    }
    return atts
  }

  public setLocalDbFields(guid: string, status: string) {
    this.localDbGuidFieldName = guid
    this.localDbStatusFieldName = status
  }
}
